<template>
    <div class="page-content">
        <script data-n-head="true" type="application/ld+json">{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://GameEnable.com/faq",
                    "name": "Blog"
                }
            ]
        }</script>
        <v-row>
            <v-col cols="12" sm="12">

                <v-col class="blog-post-card" md="12" lg="12" sm="12" v-for="(item, index  ) in items"
                       :key="index" style="display:inline-block;position:relative;">
                    <div class="blog-post-image">
                        <v-img
                                class="white--text align-end"

                                :width="item.imageWidth"
                                :height="item.imageHeight"
                                style="position: absolute;left: 0px;right:0;top: 0px;bottom: 0px;margin: auto;z-index: 2;"
                                :src="require(`@/assets/${item.image}`)"
                        />
                    </div>
                    <v-card
                            class="mx-auto"
                            style="padding-left:250px;"

                    >


                        <v-card-title>
                            <router-link :to="'article/'+item.link" style="text-decoration: none;"
                                         class="text--primary"> {{item.header}}
                            </router-link>
                        </v-card-title>


                        <v-card-subtitle class="pb-0" v-text="item.subject"></v-card-subtitle>

                        <v-card-text class="text--primary" v-text="item.subtitle">

                        </v-card-text>

                        <v-card-actions>
                            <router-link :to="'article/'+item.link" style="text-decoration: none;">
                                <v-btn
                                        color="pink"
                                        text
                                        class="float-right"

                                >
                                    <span v-html="$t('blog.readMoreLink')"></span>
                                </v-btn>
                            </router-link>
                            <v-spacer></v-spacer>
                            <div style="font-weight:300;margin-right:15px;font-size:14px!important;">
                                {{formatDate(item.date)}}
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-col>

            </v-col>


        </v-row>

    </div>
</template>

<style>


    .mobile .blog-post-card .v-card {
        padding-left: 0 !important;
        padding-top: 150px;
    }

    .blog-post-image {
        position: absolute;
        left: 11px;
        top: 0px;
        bottom: 0px;
        margin: auto;
        z-index: 2;
        height: 161px;
        width: 250px;
    }

    .mobile .blog-post-card .blog-post-image {
        height: 100px;
        position: absolute;
        left: 0;
        right: 0;
        top: 45px;
        bottom: auto;
    }

    .text-action {

        color: #EF44AE;
        background: linear-gradient(90deg, rgba(255, 81, 82, 1) 0%, rgba(255, 55, 117, 1) 49%, rgba(254, 0, 148, 1) 100%);;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }

</style>

<script>


    import i18n from "@/i18n";
    import Page from '../mixins/page'

    export default {
        name: 'Blog',
        mixins: [Page],
        computed: {
            pageTitle() {
                return i18n.t('blog.pageTitle');
            },
          pageDescription(){
            return i18n.t('blog.pageDescription');
          },
            items() {
                return [
                    {
                        header: i18n.t('blog.howToAccessFromiOSBlogTitle'),
                        imageHeight: '131px',
                        imageWidth: '110px',
                        image: 'idevices.png',
                        subtitle: i18n.t('blog.howToAccessFromiOSBlogSubtitle'),
                        subject: i18n.t('blog.howToAccessFromiOSBlogSubject'),
                        link: 'how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv',
                        date: new Date('04/06/2021')
                    },
                    {
                        header: i18n.t('blog.howToAccessFromChromeCastBlogTitle'),
                        imageHeight: '131px',
                        imageWidth: '110px',
                        image: 'chrome-cast.png',
                        subtitle: i18n.t('blog.howToAccessFromChromeCastBlogSubtitle'),
                        subject: i18n.t('blog.howToAccessFromChromeCastBlogSubject'),
                        link: 'how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra',
                        date: new Date('04/06/2021')
                    },
                    {
                        header: i18n.t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogTitle'),
                        imageHeight: '131px',
                        imageWidth: '110px',
                        image: 'destiny2.png',
                        subtitle: i18n.t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogSubtitle'),
                        subject: i18n.t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogSubject'),
                        link: 'how-to-play-destiny-2-on-stadia-without-subscription-from-unsupported-country',
                        date: new Date('12/11/2020')
                    },
                    {
                        header: i18n.t('blog.improveConnectionBlogTitle'),
                        imageWidth: '210px',
                        imageHeight: '120px',
                        image: 'performance-blog.png',
                        subtitle: i18n.t('blog.improveConnectionBlogSubtitle'),
                        subject: i18n.t('blog.improveConnectionBlogSubject'),
                        link: '4-ways-to-improve-your-Stadia-connection',
                        date: new Date('7/24/2020')
                    },
                    {
                        header: i18n.t('blog.registerUnsupportedCountriesBlogTitle'),
                        imageHeight: '131px',
                        imageWidth: '110px',
                        image: 'registerUser-blog-unsupported.png',
                        subtitle: i18n.t('blog.registerUnsupportedCountriesBlogSubtitle'),
                        subject: i18n.t('blog.registerUnsupportedCountriesBlogSubject'),
                        link: 'how-to-register-a-stadia-account-from-unsupported-country',
                        date: new Date('7/5/2020')
                    },
                    {
                        header: i18n.t('blog.registerStadiaAccountBlogTitle'),
                        imageWidth: '110px',
                        imageHeight: '131px',
                        image: 'registerUser-blog.png',
                        subtitle: i18n.t('blog.registerStadiaAccountBlogSubtitle'),
                        subject: i18n.t('blog.registerStadiaAccountBlogSubject'),
                        link: 'how-to-register-a-stadia-account',
                        date: new Date('7/3/2020')
                    }
                ]
            }
        },
        data: () => ({}),
        methods: {
            formatDate(date) {

                const dateTimeFormat = new Intl.DateTimeFormat('en', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit'
                })
                const [{value: weekday}, {}, {value: month}, {}, {value: day}, {}, {value: year}] = dateTimeFormat.formatToParts(date);

                return `${weekday} ${month} ${day} ${year}`

            }
        }
    };
</script>
